module.exports = __webpack_public_path__ + "static/media/investor4.e389169b.svg";